import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'

// style
import './style/Global.css'
import './style/App.css'

// context
import { AppProvider } from './context/AppContext.jsx'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </React.StrictMode>,
)